import { createActionGroup, props } from '@ngrx/store';
import { ImpersonationSession, ImpersonationSessionsQuery, PaginatedResult } from '@niko-crm/ui';

export const ImpersonationSessionActions = createActionGroup({
  source: 'admin-ImpersonationSessions',
  events: {
    'Load Sessions': props<{ query: ImpersonationSessionsQuery }>(),
    'Load Sessions Success': props<{ result: PaginatedResult<ImpersonationSession> }>(),
    'Load Sessions Failure': props<{ error: string }>(),
    'Revoke Session': props<{ id: string }>(),
    'Revoke Session Success': props<{ id: string }>(),
    'Revoke Session Failure': props<{ error: string }>(),
  },
});
